import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Scan, ArrowUpRight } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const LINKS = [
  { label: "Manifesto", href: "#manifesto" },
  { label: "Modalities", href: "#modalities" },
  { label: "Platform", href: "#platform" },
  { label: "Oncology", href: "#oncology" },
  { label: "Demo", href: "#demo" },
  { label: "Pricing", href: "#pricing" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar() {
  const { user } = useAuth();
  return (
    <motion.header
      initial={{ y: -80 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
      className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-xl border-b border-slate-200"
      data-testid="main-navbar"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 group" data-testid="nav-logo">
          <span className="w-8 h-8 bg-brand rounded-lg flex items-center justify-center transition-colors duration-300 group-hover:bg-[#0F172A]">
            <Scan className="w-4 h-4 text-white transition-colors duration-300 group-hover:text-white" />
          </span>
          <span className="font-display font-800 tracking-tight text-lg font-extrabold">X-GEN.AI</span>
        </Link>
        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <a
              key={l.label}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="font-mono text-xs uppercase tracking-[0.2em] text-mute hover:text-slate-900 transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
          <Link
            to="/compliance"
            data-testid="nav-link-trust"
            className="font-mono text-xs uppercase tracking-[0.2em] text-mute hover:text-slate-900 transition-colors duration-300"
          >
            Trust
          </Link>
        </nav>
        <div className="flex items-center gap-3">
          {user ? (
            <Link
              to="/dashboard"
              data-testid="nav-dashboard-button"
              className="flex items-center gap-1.5 bg-[#0F172A] text-white font-mono text-xs uppercase tracking-[0.15em] px-4 py-2.5 rounded-full hover:bg-brand hover:text-white transition-colors duration-300"
            >
              Dashboard <ArrowUpRight className="w-3.5 h-3.5" />
            </Link>
          ) : (
            <>
              <Link
                to="/login"
                data-testid="nav-signin-button"
                className="font-mono text-xs uppercase tracking-[0.15em] text-mute hover:text-slate-900 transition-colors duration-300 px-3 py-2"
              >
                Sign In
              </Link>
              <Link
                to="/register"
                data-testid="nav-access-button"
                className="hidden sm:flex items-center gap-1.5 bg-[#0F172A] text-white font-mono text-xs uppercase tracking-[0.15em] px-4 py-2.5 rounded-full hover:bg-brand hover:text-white transition-colors duration-300"
              >
                Get Access <ArrowUpRight className="w-3.5 h-3.5" />
              </Link>
            </>
          )}
        </div>
      </div>
    </motion.header>
  );
}
